<div class="db-setup-questions-step">
  <div class="db-setup-questions-left-section">
    <div class="db-setup-questions-left-section-wrap">
      <div class="db-setup-questions-left-section-small-title">
        <img src="assets/images/illustrations/setup/waving-hand.svg" alt=""/>
        <span>Hey {{user?.firstName}}!</span>
      </div>
      <div class="db-setup-questions-left-section-big-title" [innerHTML]="'text_addWebsiteWelcome' | dbText"></div>
      <div class="db-setup-questions-left-section-desc"
           [innerHTML]="(boosterClient && userSubscription?.product_id !== '205' ? 'text_letsCustomizeBooster' : 'text_letsCustomize') | dbText"></div>
    </div>
  </div>
  <div class="db-setup-questions-step-wrap-blocks" [@slide]="activeQuestionIndex">
    <div class="db-setup-questions-step-wrap-block-item">
      <div class="db-setup-questions-step-wrap-block-question" [innerHtml]="questions[activeQuestionIndex].question"></div>
      <div class="db-setup-questions-step-wrap-block-answers-wrap" [style.pointer-events]="lastSelected ? 'none' : 'unset'">
        <div class="db-setup-questions-step-wrap-block-answers" *ngFor="let answerItem of questions[activeQuestionIndex].answers"
             [ngClass]="{'active': answerItem.value === lastSelected}"
             (click)="goToNextQuestion(answerItem, questions[activeQuestionIndex].slug)">
          <div class="db-setup-questions-step-wrap-block-answers-title" [innerHTML]="answerItem.title"></div>
          <div class="db-setup-questions-step-wrap-block-icon"><span>
            <i class="db-icon db-icon-ds-{{answerItem.value === lastSelected ? 'checkmark-bg' : 'arrow-small'}}"></i>
          </span></div>
        </div>
      </div>
    </div>
  </div>
</div>
